import moment from 'moment';

moment.locale('zh-cn');

const forFn = (start = 0, end = 0) => {
  const array = [];
  for (let i = start; i <= end; i++) {
    array.push(i);
  }
  return array;
};

export default {
  /**
   * 格式化
   * @param value - '2023-05-29T07:06:55.095Z'
   * @param format - 'YYYY-MM-DD HH:mm:ss'
   * @returns
   */
  format: (value: string, format: string = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) return '';

    if (typeof value === 'number') {
      return moment(value).format(format);
    }

    const timeStamp = moment.utc(value).valueOf(); // 返回值为数值型
    return moment(timeStamp).format(format);
  },
  getYears: () => forFn(1949, 2070),
  getMonths: () => forFn(1, 12),
  getDays: (end: number) => forFn(1, end),
  /**
   * 判断时间是否是当天（同一天）
   * @param dateString
   * @returns
   */
  isSameDay: (dateString: string) => {
    const givenDate = moment(
      dateString,
      ['YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss', moment.ISO_8601],
      true
    );
    return givenDate.isValid() && givenDate.isSame(moment(), 'day');
  },
  /**
   * 更详细的相对时间格式化
   * @param time - ISO时间字符串
   * @returns 格式化后的相对时间
   *
   * 规则：
   * 1. 1分钟内：刚刚
   * 2. xx分钟前
   * 3. xx小时前
   * 4. 昨天/前天
   * 5. xx天前（7天内）
   * 6. MM-DD HH:mm（本年内）
   * 7. YYYY-MM-DD HH:mm（其他年份）
   */
  formatRelativeTime: (time: string): string => {
    const momentTime = moment(time);
    const now = moment();

    if (!momentTime.isValid()) return '';

    const diff = now.diff(momentTime, 'minutes');
    const isThisYear = momentTime.year() === now.year();

    // 1分钟内
    if (diff < 1) {
      return '刚刚';
    }

    // 1小时内
    if (diff < 60) {
      return `${diff}分钟前`;
    }

    // 24小时内
    const hourDiff = now.diff(momentTime, 'hours');
    if (hourDiff < 24) {
      return `${hourDiff}小时前`;
    }

    // 7天内
    const dayDiff = now.diff(momentTime, 'days');
    if (dayDiff === 1) {
      return '昨天';
    }
    if (dayDiff === 2) {
      return '前天';
    }
    if (dayDiff <= 7) {
      return `${dayDiff}天前`;
    }

    // 本年内
    if (isThisYear) {
      return momentTime.format('MM-DD HH:mm');
    }

    // 其他年份
    return momentTime.format('YYYY-MM-DD HH:mm');
  },
};
